import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_FRAME_COLOR, SEARCH_PARAM_KEY_FRAME_STYLE, SEARCH_PARAM_KEY_LAYOUT } from '../../constants/searchParamKeys';
import { isNullOrUndef } from '../../../../utils/isNullOrUndef';
export const FlatPreview = ({ data: { art, x, y, frameTypes, room }, srcSetMaxSize, imageAlt = '', className = '' }) => {
    const [searchParams] = useSearchParams();
    const componentRef = useRef(null);
    const frameStyle = searchParams.get(SEARCH_PARAM_KEY_FRAME_STYLE);
    const activeLayout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT);
    const frameColor = searchParams.get(SEARCH_PARAM_KEY_FRAME_COLOR);
    useEffect(() => {
        if (isNullOrUndef(componentRef.current) ||
            isNullOrUndef(activeLayout) ||
            isNullOrUndef(frameStyle) ||
            isNullOrUndef(frameColor))
            return;
        const { thickness, width } = frameTypes[frameStyle];
        componentRef.current._srcSetMaxSize = srcSetMaxSize;
        componentRef.current._alt = imageAlt;
        componentRef.current._data = {
            room,
            art,
            x,
            y,
            width,
            thickness,
            layout: activeLayout,
            style: frameStyle,
            color: frameColor
        };
    }, [activeLayout, frameStyle, frameColor, art, room]);
    return (React.createElement("flat-preview-component", { class: `d:block pos:r lh:0 ar:1 bg:f4f4f4 ${className}`, ref: componentRef }));
};
